export var DATE_PICKER_TOP_BAR_CLASS_PREFIX = 'DatePickerTopBar';